interface CalendarData {
    id: string;
    name: string;
}

interface PractitionerData {
    id: string;
    name: string;
    calendars: CalendarData[];
}

export const getCalendarIdFromName = (
    data: PractitionerData[],
    name: string
): [calendarId: string, practitionerId: string] | undefined => {
    for (const practitioner of data) {
        if (practitioner.calendars.length === 1) {
            if (name === practitioner.name) {
                return [practitioner.calendars[0].id, practitioner.id];
            }
        } else {
            const matchedCalendar = practitioner.calendars.find((calendar) => calendar.name === name);
            if (matchedCalendar) {
                return [matchedCalendar.id, practitioner.id];
            }
        }
    }
    return undefined;
};

export const getSearchFromCalendarId = (data: PractitionerData[], calendarId?: string): string => {
    if (!calendarId) return '';
    for (const practitioner of data) {
        const matchedCalendar = practitioner.calendars.find((c) => c.id === calendarId);
        if (matchedCalendar) {
            return practitioner.calendars.length > 1 ? matchedCalendar.name : practitioner.name;
        }
    }
    return '';
};

export const getSingleCalendarId = (data: PractitionerData[]): string | undefined => {
    const all = data.flatMap((p) => p.calendars);
    return all.length === 1 ? all[0].id : undefined;
};

export const isCalendarSearchValid = (data: PractitionerData[], search: string): boolean => {
    return getCalendarIdFromName(data, search) !== undefined;
};

export const filterPractitionersBySearch = (data: PractitionerData[], search: string): PractitionerData[] => {
    const filteredGroups: PractitionerData[] = [];
    const searchLower = search.toLowerCase().trim();

    for (const practitioner of data) {
        if (practitioner.calendars.length > 1) {
            const filteredCalendars = practitioner.calendars.filter((item) =>
                item.name.toLowerCase().includes(searchLower)
            );
            if (filteredCalendars.length > 0) {
                filteredGroups.push({ ...practitioner, calendars: filteredCalendars });
            }
        } else {
            if (practitioner.name.toLowerCase().includes(searchLower)) {
                filteredGroups.push(practitioner);
            }
        }
    }

    return filteredGroups;
};
